import { render, staticRenderFns } from "./Dispute.vue?vue&type=template&id=18162bd5&scoped=true&"
import script from "./Dispute.vue?vue&type=script&lang=js&"
export * from "./Dispute.vue?vue&type=script&lang=js&"
import style0 from "./Dispute.vue?vue&type=style&index=0&id=18162bd5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18162bd5",
  null
  
)

export default component.exports